import React from 'react';
import { Box } from '@mui/material';
import {
  OperationProgressPlaceholder,
  type OperationProgressModel,
} from '../../../../shared/ui/progress';

interface MappingWorkspaceLoadingPlaceholderProps {
  model: OperationProgressModel;
}

/**
 * Full-workspace loading page for the mapping tab. Fills the same flex frame
 * as MappingWorkspaceCanvas so the layout does not jump when content arrives.
 */
const MappingWorkspaceLoadingPlaceholder: React.FC<MappingWorkspaceLoadingPlaceholderProps> = ({
  model,
}) => (
  <Box
    data-testid="mapping-workspace-loading"
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: 0,
    }}
  >
    <OperationProgressPlaceholder model={model} />
  </Box>
);

export default MappingWorkspaceLoadingPlaceholder;
